// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import {Message} from 'element-ui'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {user_info} from "@/api/user";
import VueMeta from 'vue-meta'
import {VueJsonp} from 'vue-jsonp'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import server from '@/utils/serve.js'
Vue.use(VueJsonp);
Vue.use(VueMeta);
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    let that = this;
  if (to.matched.some(m => m.meta.requireAuth)) {  
    if(sessionStorage.getItem('user')&&sessionStorage.getItem('user')!="null"&&sessionStorage.getItem('user')!=null){
      store.state.hasLogin = true
    }		
    // 对路由进行验证
    if (store.state.hasLogin) { // 已经登陆
	
		if(to.name!='renzheng'){
			// 判断是否填写资料
			user_info().then(res=>{
				let data =res.data;
				if(data.is_cert!=2){
					next({path:'/renzheng'}) 
				}else{
					document.documentElement.scrollTop = 0
					if (to.meta.title) {
					  document.title = to.meta.title
					}
					next() // 正常跳转到你设置好的页面
				}
				
			})
			
			
		}else{
			
			document.documentElement.scrollTop = 0
			if (to.meta.title) {
			  document.title = to.meta.title
			}
			next() // 正常跳转到你设置好的页面
		}
      
    } else {
      //未登录则跳转到登陆界面
      Message({
        message: '您还未登录请先去登录',
        type: 'error',
        duration: 5 * 100
      })
	  setTimeout(res=>{
		  next({ path: '/login' })
	  },1000)
    }
  } else {
	
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    document.documentElement.scrollTop = 0
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data: function(){
      return {
          tipNum: 0,
      }
  },
  components: { App },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js